<div class="-mt-1">
  <div
    class="flex rounded-2xl items-stretch overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden bg-white border border-slate-200"
  >
    @for (meta of stages; track meta.state) {
      <div class="relative flex-1 min-w-[130px] md:min-w-[150px] snap-start h-full">
        <button
          type="button"
          [class]="stageBtnClass(meta.state)"
          [disabled]="isDisabled(meta.state)"
          (click)="onStageTabClick(meta.state)"
          (mouseenter)="showPopover(meta.state, $event)"
          (mouseleave)="scheduleHidePopover()"
        >
          <span [class]="numberBadgeClass(meta.state)">{{ numberFor(meta.state) }}</span>
          <span class="flex flex-col min-w-0 flex-1">
            <span [class]="labelClass(meta.state)">{{ labelFor(meta.state) }}</span>
            <span [class]="statusTextClass(meta.state)">
              <span [class]="statusDotClass(meta.state)"></span>
              {{ statusLabel(meta.state) }}
            </span>
          </span>
        </button>
      </div>
    }
  </div>
</div>

@if (popover) {
  <div
    class="fixed -translate-x-1/2 bg-white/[0.98] backdrop-blur-[16px] text-slate-900 rounded-xl py-3.5 px-[18px] max-w-[300px] w-max border border-slate-200/90 shadow-[0_4px_16px_rgba(0,0,0,0.08),0_1px_3px_rgba(0,0,0,0.04)] z-[1000] animate-[tooltip-enter_0.15s_cubic-bezier(0.4,0,0.2,1)] before:content-[''] before:absolute before:top-[-5px] before:left-1/2 before:-translate-x-1/2 before:rotate-45 before:w-2.5 before:h-2.5 before:bg-white/[0.98] before:border-l before:border-t before:border-slate-200/90 before:rounded-tl-sm"
    [style.left.px]="popover.x"
    [style.top.px]="popover.y"
  >
    <div class="flex items-center gap-2 mb-1.5">
      <span
        class="text-sm text-slate-900 font-semibold uppercase overflow-hidden text-ellipsis whitespace-nowrap"
        >{{ popover.meta.label }}</span
      >
    </div>
    <p class="text-[13px] text-slate-700 leading-normal mb-2.5">{{ popover.meta.description }}</p>
    <div class="flex gap-2 flex-wrap">
      <span [class]="popoverPillClass(popover.status)">
        <span [class]="popoverPillDotClass(popover.status)"></span>
        {{ popover.statusLabel }}
      </span>
    </div>
  </div>
}
